<div class="d-flex justify-content-between generic-row-item py-1" [ngClass]="{'without-sub' : withoutSub}" matRipple>
    <div class="d-flex flex-column" style="width: 100%; padding-left: 8px;" (click)="click()">
        <div class="d-flex align-items-center">
            <span>{{data.title}}</span>
            <span class="context-chip" *ngIf="data.chipLabel">{{data.chipLabel}}</span>
        </div>
        <div *ngIf="!withoutSub" style="font-size: 13px;">{{data.subTitle}}</div>
    </div>
    <div class="row-icon" [hidden]="!data.displayDelete">
        <div class="ic-center">
            <button mat-icon-button color="primary" aria-label="Example icon button with a delete icon" (click)="delete()">
                <mat-icon>delete</mat-icon>
            </button>
        </div>
    </div>

    <div style="align-self: center;" (click)="click()">
        <button mat-icon-button>
            <mat-icon>keyboard_arrow_right</mat-icon>
        </button>
    </div>
</div>

<!-- <div class="row-item" matRipple>
    <div class="title" (click)="click()">
        {{data.title}}
    </div>
    <div class="row-icon" [hidden]="!data.displayDelete">
        <div class="ic-center">
            <button mat-icon-button color="primary" aria-label="Example icon button with a delete icon" (click)="delete()">
                <mat-icon>delete</mat-icon>
            </button>
        </div>
    </div>
</div> -->
